
class HistoryIndexCell {
    constructor() {
        this.time = -1;
        this.fileName = "";
    }

}

export default HistoryIndexCell